import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  Button,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CountryDialog = ({ isOpen, onClose, submitChangeCountry, popupCountry, setPopupCountry }) => {
  const isSubmitDisabled = !popupCountry.CountryName.trim() || !popupCountry.CountryCode.trim();

  const handleInputChange = (field, value) => {
    setPopupCountry((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const Submit = () => {
    submitChangeCountry();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      {/* Header */}
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={500}>
            Add Country
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Grid container spacing={2}>
          {/* Country Name */}
          <Grid item xs={12} sm={6}>
            <Typography fontWeight={600}>Country Name *</Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={popupCountry.CountryName}
              onChange={(e) => handleInputChange("CountryName", e.target.value)}
            />
          </Grid>

          {/* Country Code */}
          <Grid item xs={12} sm={6}>
            <Typography fontWeight={600}>Country Code *</Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={popupCountry.CountryCode}
              onChange={(e) => handleInputChange("CountryCode", e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          disabled={isSubmitDisabled}
          onClick={Submit}
          sx={{
            padding: "10px",
            backgroundColor: isSubmitDisabled ? "lightGray" : " #212129",
            color: "white",
            borderRadius: "20px",
            "&:hover": {
              backgroundColor: isSubmitDisabled ? "lightGray" : "darkgray",
            },
          }}
        >
          Ok
        </Button>

        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            padding: "10px",
            border: "1px solid  #212129",
            color: " #212129",
            backgroundColor: "white",
            borderRadius: "20px",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CountryDialog;
